"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var MAG_MAX_LENGTH = 23;
function createLastMessage(message) {
    if (!message)
        return '...';
    var msg = message.msg;
    if (!msg && !lodash_1["default"].isEmpty(message.attachments)) {
        return '[image]';
    }
    if (msg.length > MAG_MAX_LENGTH)
        msg = msg.substr(0, MAG_MAX_LENGTH - 3) + "...";
    msg = msg.replace(/\s/g, ' ');
    return msg;
}
exports["default"] = createLastMessage;
